import { default as axios } from 'axios';
export var sendSignUpData = function (api, data) {
    var headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .post(api + "/api/settings/signup", data, { headers: headers }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        console.log(err);
        return null;
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Api/settingsApiClient.js
// module id = 1348
// module chunks = 0